import { ReactNode, RefObject } from 'react';

import TreeCollection from 'bloko/common/tree/treeCollection';
import { ModelData, TreeModel, AdditionalDefault } from 'bloko/common/tree/types';

import { UseRenderInputHook } from 'bloko/blocks/compositeSelection/hooks/useRenderInput';

export interface TagModel extends ModelData {
    collapsed?: boolean;
    items?: TagModel[];
}

export interface CompositeSelectionTagListProps<A extends AdditionalDefault> {
    value?: string[];
    crossedOutValue?: string[];
    collection?: TreeCollection<A>;
    nested?: boolean;
    stretched?: boolean;
    removable?: boolean;
    removeItems: (items: string[]) => void;
    renderNestedTag?: (props: { id: string; item: TreeModel<A> }) => ReactNode;
    renderNestedTagHeader?: (props: { id: string; text: string }) => ReactNode;
    crossedOutValueNameTransformation?: (text: string) => string;
    renderAfterTags?: () => ReactNode;
    renderAfterTagsRef?: RefObject<HTMLDivElement>;
}

interface ChildrenProps<A extends AdditionalDefault> {
    renderTagList: (props?: Partial<CompositeSelectionTagListProps<A>>) => ReactNode;
    renderExcludedTagList: (props?: Partial<CompositeSelectionTagListProps<A>>) => ReactNode;
    renderInput: ReturnType<UseRenderInputHook>;
    showTreeSelectorPopup: () => void;
    selectedTree: TreeModel<A>[];
}

export interface Children<A extends AdditionalDefault> {
    (props: ChildrenProps<A>): ReactNode;
}

interface FooterExtraProps {
    hideTreeSelectorPopup: () => void;
    submitTreeSelectorPopup: (selected: string[]) => void;
}

export interface FooterExtra {
    (props: FooterExtraProps): ReactNode;
}
